export function DddDiagram({ lang }: { lang: string }) {
  const en = lang === 'en';

  return (
    <div className="space-y-4">
      <div className="grid gap-4 md:grid-cols-2">
        {/* Portfolio Context */}
        <div className="rounded border-2 border-cyan-500/50 bg-bg-surface p-5">
          <div className="flex items-center gap-2">
            <span className="rounded bg-cyan-500/20 px-2 py-0.5 font-mono text-xs text-accent">
              {en ? 'Bounded Context' : 'Bounded Context'}
            </span>
          </div>
          <h4 className="mt-2 font-mono text-sm font-bold text-text-primary">Portfolio</h4>
          <div className="mt-3 space-y-2">
            <div className="rounded border border-border bg-bg-primary/50 px-3 py-2">
              <p className="font-mono text-xs text-accent">API Gateway</p>
              <p className="text-xs text-text-muted">personalweb-portfolio-{'{'}{en ? 'stage' : 'stage'}{'}'}</p>
            </div>
            <div className="rounded border border-border bg-bg-primary/50 px-3 py-2">
              <p className="font-mono text-xs text-accent">DynamoDB</p>
              <p className="text-xs text-text-muted">PK: ENTITY#type / SK: ITEM#id</p>
              <p className="text-xs text-text-muted">GSI: type-order-index</p>
            </div>
            <div className="rounded border border-border bg-bg-primary/50 px-3 py-2">
              <p className="font-mono text-xs text-accent">Lambdas</p>
              <div className="mt-1 flex flex-wrap gap-1">
                <span className="rounded bg-bg-primary px-2 py-0.5 text-xs text-text-muted">get-items</span>
                <span className="rounded bg-bg-primary px-2 py-0.5 text-xs text-text-muted">submit-contact</span>
                <span className="rounded bg-bg-primary px-2 py-0.5 text-xs text-text-muted">health</span>
              </div>
            </div>
            <div className="rounded border border-border bg-bg-primary/50 px-3 py-2">
              <p className="font-mono text-xs text-accent">{en ? 'Entities' : 'Entidades'}</p>
              <div className="mt-1 flex flex-wrap gap-1">
                {['EXPERIENCE', 'CERTIFICATION', 'PROJECT', 'SKILL', 'PROFILE', 'CONTACT'].map((e) => (
                  <span key={e} className="rounded bg-cyan-500/10 px-2 py-0.5 text-xs text-accent">{e}</span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* AI Chat Context */}
        <div className="rounded border-2 border-purple-500/50 bg-bg-surface p-5">
          <div className="flex items-center gap-2">
            <span className="rounded bg-purple-500/20 px-2 py-0.5 font-mono text-xs text-purple-400">
              {en ? 'Bounded Context' : 'Bounded Context'}
            </span>
          </div>
          <h4 className="mt-2 font-mono text-sm font-bold text-text-primary">AI Chat</h4>
          <div className="mt-3 space-y-2">
            <div className="rounded border border-border bg-bg-primary/50 px-3 py-2">
              <p className="font-mono text-xs text-purple-400">API Gateway</p>
              <p className="text-xs text-text-muted">personalweb-ai-chat-{'{'}{en ? 'stage' : 'stage'}{'}'}</p>
              <p className="text-xs text-text-muted">{en ? '+ API Key + Usage Plan' : '+ API Key + Usage Plan'}</p>
            </div>
            <div className="rounded border border-border bg-bg-primary/50 px-3 py-2">
              <p className="font-mono text-xs text-purple-400">DynamoDB</p>
              <p className="text-xs text-text-muted">PK: SESSION#id / SK: MSG#timestamp</p>
              <p className="text-xs text-text-muted">TTL: expiresAt</p>
            </div>
            <div className="rounded border border-border bg-bg-primary/50 px-3 py-2">
              <p className="font-mono text-xs text-purple-400">AWS Bedrock</p>
              <p className="text-xs text-text-muted">Claude Haiku · {en ? 'Hardened system prompt' : 'System prompt blindado'}</p>
            </div>
            <div className="rounded border border-border bg-bg-primary/50 px-3 py-2">
              <p className="font-mono text-xs text-purple-400">{en ? 'Observability' : 'Observabilidad'}</p>
              <div className="mt-1 flex flex-wrap gap-1">
                <span className="rounded bg-bg-primary px-2 py-0.5 text-xs text-text-muted">CloudWatch Alarm</span>
                <span className="rounded bg-bg-primary px-2 py-0.5 text-xs text-text-muted">SNS</span>
                <span className="rounded bg-bg-primary px-2 py-0.5 text-xs text-text-muted">X-Ray</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className="text-center font-mono text-xs text-text-muted">
        {en
          ? '↑ Each domain has its OWN API Gateway, DynamoDB table, and Lambdas. Zero coupling.'
          : '↑ Cada dominio tiene su PROPIO API Gateway, tabla DynamoDB y Lambdas. Cero acoplamiento.'}
      </p>
    </div>
  );
}
